<template>
  <div
    class="rounded-lg border p-3 text-sm"
    :class="
      danger
        ? 'border-red-200 bg-red-50 text-red-900'
        : 'border-blue-200 bg-blue-50 text-blue-900'
    "
    role="alertdialog"
    :aria-label="confirmLabel"
    data-cy="webhook-confirm"
  >
    <p class="m-0 mb-3">
      <slot>{{ message }}</slot>
    </p>
    <div class="flex flex-wrap gap-2">
      <button
        type="button"
        class="rounded-lg px-3 py-1.5 text-sm font-medium text-white disabled:opacity-60"
        :class="
          danger
            ? 'bg-red-700 hover:bg-red-800'
            : 'bg-blue-700 hover:bg-blue-800'
        "
        :disabled="busy"
        data-cy="webhook-confirm-yes"
        @click="emit('confirm')"
      >
        {{ busy ? "Working…" : confirmLabel }}
      </button>
      <button
        type="button"
        class="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
        :disabled="busy"
        data-cy="webhook-confirm-cancel"
        @click="emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
// A confirmation built into the page rather than a browser dialog: the
// question sits next to the action it guards.
withDefaults(
  defineProps<{
    message?: string;
    confirmLabel: string;
    danger?: boolean;
    busy?: boolean;
  }>(),
  { message: "", danger: false, busy: false }
);
const emit = defineEmits<{ confirm: []; cancel: [] }>();
</script>
